import { Link } from "react-router-dom"
import { urlsPages } from "../../../common/urls/urls-pages"

export function FinalCTA() {
  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        style={{ background: "radial-gradient(ellipse at center, rgba(0,255,179,0.18), transparent 60%)" }}
      />
      <div className="absolute inset-0 -z-10 bg-grid opacity-30 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />

      <div className="mx-auto max-w-3xl px-6 text-center">
        <h2 className="text-4xl md:text-6xl font-extrabold tracking-tight">
          Pronto para treinar com <span className="text-primary text-glow">estímulos</span>?
        </h2>
        <p className="mt-5 text-lg text-muted-foreground">
          Crie sua conta grátis e comece agora. Sem cartão de crédito.
        </p>
        <div className="mt-10">
          <Link
            to={urlsPages.signup}
            className="inline-flex items-center rounded-full bg-primary px-8 py-4 text-base font-bold text-primary-foreground glow-primary hover:scale-105 transition-transform"
          >
            Criar conta grátis →
          </Link>
        </div>
        <p className="mt-5 text-sm text-muted-foreground">
          Já tem uma conta?{" "}
          <Link to={urlsPages.signin} className="text-primary hover:underline font-semibold">
            Fazer login
          </Link>
        </p>
      </div>
    </section>
  )
}
